import { useI18n } from '../i18n/i18n-context';
import { AppLink } from './AppLink';
import type { AppView } from './useAppView';

// The pages people choose between. The desktop apps have their own link beside the account.
const views: readonly AppView[] = ['home', 'write', 'guide', 'pricing'];

export function AppNavigation({ view }: { readonly view: AppView }) {
  const { t } = useI18n();
  return (
    <nav className="site-navigation" aria-label={t.navigation.label}>
      {views.map((id) => (
        <AppLink
          key={id}
          className="site-navigation-link"
          to={id}
          aria-current={view === id ? 'page' : undefined}
        >
          {t.navigation[id]}
          {view === id && <span className="site-navigation-indicator" aria-hidden="true" />}
        </AppLink>
      ))}
    </nav>
  );
}
